export default "__VITE_ASSET__CTGOtlnQ__"